import * as React from 'react';
import './marker.css';


export class Marker extends React.Component<any> {
    render() {
        return (
            <div id='marker'>
                <div className='pin' />
                <div className='pulse' />
            </div>
        )
    }
}

export default Marker;


// WEBPACK FOOTER //
// ./src/components/Marker.tsx